var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5.92297H6.407V12.354C6.407 15.446 8.923 17.963 12.016 17.963C15.108 17.963 17.625 15.446 17.625 12.354V5.92297H18.75C19.164 5.92297 19.5 5.58697 19.5 5.17297C19.5 4.75897 19.164 4.42297 18.75 4.42297H14.968C14.554 4.42297 14.218 4.75897 14.218 5.17297C14.218 5.58697 14.554 5.92297 14.968 5.92297H16.125V12.354C16.125 14.62 14.282 16.463 12.016 16.463C9.75 16.463 7.907 14.62 7.907 12.354V5.92297H9.032C9.446 5.92297 9.782 5.58697 9.782 5.17297C9.782 4.75897 9.446 4.42297 9.032 4.42297H5.25C4.836 4.42297 4.5 4.75897 4.5 5.17297C4.5 5.58697 4.836 5.92297 5.25 5.92297Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 19.077H5.25C4.836 19.077 4.5 19.413 4.5 19.827C4.5 20.241 4.836 20.577 5.25 20.577H18.75C19.164 20.577 19.5 20.241 19.5 19.827C19.5 19.413 19.164 19.077 18.75 19.077Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.af7fa50845d2784d446e92360b1f6033.svg";
export { ForwardRef as ReactComponent };